import BaseSingleClass from "@/base/BaseSingleClass";

export default class APIHelper extends BaseSingleClass{
    //测试环境
    private baseURL='http://app6.fenzhidao.com/inEnglish/api/v1/evaluation/'
    getJson(url:string):Promise<any>{
        return new Promise<any>((resolve,reject)=>{
            fetch(url).then(response=>{
                if(response.ok){
                    response.text().then(res=>{
                        const json=JSON.parse(res)
                        resolve(json)
                    })
                }else{
                    reject(response)
                }
            })
        })
    }
    /**
     * request请求，所有接口都基于这个封装
     * @param url 地址
     * @param config 配置(method,headers,body)
     * @returns 
     */
    private request(url:string,config:any):Promise<any>{
        return new Promise<any>((resolve,reject)=>{
            const link=(url.indexOf('http')==-1)?this.baseURL+url:url
            fetch(link,config).then(response=>{
                if(response.ok){
                    response.text().then(res=>{
                        const json=JSON.parse(res)
                        /**
                         * 200表示成功，其他表示失败，例如-50表示token失效，根据项目实际需求作修改
                         */
                        if(json.code==200){
                            //console.log(json.data)
                            resolve(json)
                        }else if(json.code==500){
                            reject(json)
                        }else if(json.code==-50){
                            //token失效，弹窗提示
                            
                            alert('账号异常提醒')
                            
                        }else{
                            //console.error(json.message)
                            //director.emit(GameEvent.SHOW_TOAST,json.message)
                            reject(json)
                        }
                    }).catch(reject)
                }else{
                    reject(response)
                }
            }).catch(reject)
        })
        //return fetch(this.baseURL+url,config)
    }
}